import React, { useEffect, useState } from "react";
import _ from "lodash";
import cx from "classnames";
import { Button, Radio, Flex, Spin } from "antd";
import type { RadioChangeEvent, CheckboxOptionType } from "antd";
import { CheckSquareOutlined, LoadingOutlined } from "@ant-design/icons";
import { ToastContainer, toast } from "react-toastify";
import voteService from "../../services/voteService";
import useStyle from "../../hooks/useStyle";
import { MOVIES } from "./movies";
import style from "./Vote.module.scss";

export default function Vote() {
    const { styles } = useStyle();
    const [day] = useState(3);
    const [choice, setChoice] = useState("");
    const [voted, setVoted] = useState(false);
    const [cookieChecked, setCookieChecked] = useState(false);

    // Cookie helpers to persist a user's vote
    const setCookie = (name: string, value: string, days: number) => {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        const expires = "; expires=" + date.toUTCString();
        document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=/; SameSite=Lax`;
    };

    const getCookie = (name: string) => {
        const nameEQ = name + "=";
        const parts = document.cookie.split(";");

        for (let i = 0; i < parts.length; i++) {
            let c = parts[i];
            while (c.charAt(0) === " ") c = c.substring(1);
            if (c.indexOf(nameEQ) === 0) {
                return decodeURIComponent(c.substring(nameEQ.length));
            }
        }

        return null;
    };

    // Read the vote from cookie on mount
    useEffect(() => {
        const cookieName = `vote_day_${day}`;
        const savedChoice = getCookie(cookieName);
        if (savedChoice) {
            setChoice(savedChoice);
            setVoted(true);
        }
        setCookieChecked(true);
    }, [day]);

    const onChangeChoice = (e: RadioChangeEvent) => {
        setChoice(e.target.value);
    };

    const vote = async () => {
        if (!choice) {
            toast.error(`Ви не обрали фільм. Зробіть вибір і проголосуйте знову.`, {
                theme: "colored",
            });
            return;
        }
        try {
            await voteService.submitVote(day, choice);
        } catch {
            toast.error(`Не вдалося надіслати ваш голос. Спробуйте ще раз.`, {
                theme: "colored",
            });
            return;
        }

        // Persist vote in cookie to prevent re-voting
        const cookieName = `vote_day_${day}`;
        setCookie(cookieName, choice, 10);

        setVoted(true);
    };

    if (!cookieChecked) {
        return (
            <Flex className={style.spin} align="center" justify="center" gap="middle">
                <Spin indicator={<LoadingOutlined style={{ fontSize: 48, color: "#E4C45C" }} spin />} />
            </Flex>
        );
    }
    return (
        <div className={cx(style.root, style.voted)}>
            <h3 className={style.firstHead}>Голосування закінчено, дякуємо за участь! 🤗</h3>
        </div>
    );

    if (voted) {
        const movie = MOVIES[day][choice];
        if (!movie) {
            return null;
        }

        return (
            <div className={cx(style.root, style.voted)}>
                <h3 className={style.firstHead}>Ви успішно проголосували за фільм:</h3>
                <a className={style.choice} href={movie.link} target="_blank" rel="noreferrer">
                    <div className={style.choiceTitle}>{movie.name}</div>
                    <img src={movie.img} alt="" />
                </a>
                <div>
                    <h4>У Вас чудовий смак і Ви неймовірні! 🤗</h4>
                </div>
                {/*<p>Дякуємо за Ваш вибір!</p>*/}
            </div>
        );
    }

    const options = _.map(MOVIES[day], (movie, key) => {
        return {
            value: key,
            label: (
                <div className={style.radioItem}>
                    <img src={movie.img} alt="" />
                    {movie.name}
                </div>
            ),
        } as CheckboxOptionType;
    });

    return (
        <div className={style.root}>
            <ToastContainer className={style.toast} />

            <h3 className={style.firstHead}>Оберіть найкраший фільм за сьогодні:</h3>

            <Radio.Group className={style.radioGroup} onChange={onChangeChoice} value={choice} options={options} />

            <div className={style.submitBtnWrapper}>
                <Button
                    className={cx(styles.linearGradientButton, style.submitBtn)}
                    type="primary"
                    size="large"
                    icon={<CheckSquareOutlined />}
                    onClick={vote}
                >
                    Проголосувати
                </Button>
            </div>
        </div>
    );
}
